/* eslint-disable */
import Vue from "vue";
import VueI18n from "vue-i18n";
import ShardsVue from "shards-vue";
import store from "./store/store";
import router from "./router";
import init from "./initializer/initializer";
import VModal from "vue-js-modal";
import VueEllipseProgress from 'vue-ellipse-progress';

// Init our instances in Vue
init(store);

// Styles
import "bootstrap/dist/css/bootstrap.css";
import "@/assets/shards-dashboard-pro/shards-dashboards.scss";
import "@/assets/scss/date-range.scss";

// Core
import App from "./App.vue";

import vuetify from "./plugins/vuetify";

ShardsVue.install(Vue);

Vue.use(VueI18n);
Vue.use(VModal);
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false } });
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(VueEllipseProgress);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

const i18n = new VueI18n({
  locale: "fr",
  fallbackLocale: "fr",
  messages: {
    fr: require("@/locales/fr.json")
  }
});

new Vue({
  router,
  i18n,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
